module.exports = __webpack_public_path__ + "img/Hong Leong.cd585690.png";